import {cn, Icons} from '@continuum/ui';

interface ChatFabProps {
  onClick: () => void;
  visible: boolean;
  shifted?: boolean;
  className?: string;
}

export const ChatFab = ({
  onClick,
  visible,
  shifted = false,
  className,
}: ChatFabProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label="Open chat"
      className={cn(
        'fixed bottom-6 right-6 z-40 flex size-14 items-center justify-center rounded-full bg-(--canvas-primary) shadow-lg transition-[margin-right,transform,opacity] duration-300 ease-in-out hover:shadow-xl active:scale-95',
        visible
          ? 'scale-100 opacity-100'
          : 'pointer-events-none scale-0 opacity-0',
        shifted && 'mr-(--canvas-panel-width)',
        className,
      )}
    >
      <Icons.messageSquare className="size-6 text-(--canvas-primary-foreground)" />
    </button>
  );
};
